/**
 * Customized Badge component.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma Reference: https://www.figma.com/file/Z8kfGR6BNKMm3XvQGhKcBD/PINS-Advantage-2021-Design-System?node-id=5%3A3
 */

const StatusBadge = {
  baseStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    borderRadius: '4px',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem'
  },
  sizes: {
    sm: {
      height: '32px',
      fontSize: '13px',
      fontWeight: '500',
      lineHeight: '18px'
    },
    md: {
      height: '40px',
      fontSize: '15px',
      fontWeight: '500',
      lineHeight: '18px',
      paddingLeft: '0.75rem',
      paddingRight: '0.75rem'
    },
    lg: {
      height: '48px',
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '18px',
      paddingLeft: '1rem',
      paddingRight: '1rem'
    }
  }
};

export default StatusBadge;
